import loadable from '@loadable/component';

export const CompensationSurveyLoadable = loadable(
  () =>
    import(
      /* webpackChunkName: "CompensationSurvey" */
      './CompensationSurvey.dynamic'
    ),
);
